<div class="text-center">
    <h3 class="text-center text-mid text-secondary-dark">¡Recuerda!</h3>
    <p class="mb-mid">Para comprar servicios adicionales o hacer uso de ellos debes tener al menos un inmueble activo en Ciencuadras</p>
    <button class="button secondary rounded" mat-dialog-close>continuar</button> 
</div>